export const FAQLIST = "FAQLIST"
export const FAQCREATE ="FAQCREATE"
export const FAQSTATUSCHANGES = "FAQSTATUSCHANGES"
export const FAQUPDATE = "FAQUPDATE"
export const FAQDETAILS = "FAQDEAILS"
export const FAQDELETE = "FAQDELETE"